import React, { Component } from 'react'
import styles from "./Donation.module.css"

import PaySubBtn from "../util/PaypalApi/PaySubBtn"

import YouTube from 'react-youtube';
import WALLPAPER_INTRO_SRC from "../static/My-Layout-wallpaper.png"
export default class Donation extends Component {
    constructor(props) {
        super(props)
    }
    // handler
    paypalOnError = (err) => { console.log("Error") }
    paypalOnApprove = (data, detail) => {
        // call the backend api to store transaction details
        console.log("Payapl approved", data.subscriptionID, this.state.user)
    };

    // component
    VideoDespComponent = () => {
        const opts = {
            height: '720',
            width: '1280',
            playerVars: {
                // https://developers.google.com/youtube/player_parameters
                loop: 1
            },
        };

        return (
            <div className={styles.schematicStyle}>
                <YouTube videoId={process.env.REACT_APP_HOME_VID_ID} opts={opts} />
            </div>
        )
    }

    wallpaperDespComp = () => {
        return (
            <div className={styles.wallpaperIntoStyle}>
                <img src={WALLPAPER_INTRO_SRC} alt="" srcset="" />
            </div>
        )
    }

    donationContent = () => {
        return (
            <div className={styles.contentStyle}>
                <h1>Keep tool more further</h1>
                <p>
                    {/* This is non-profit tool website and provide collect tool with your shoot resources. */}
                    {/* <br /><br /> */}
		            Your donation will help for hositing and future developement cost
                    <br /><br />
		            That would helpful for me to make this site further improvement.
		            Also if you have any good idea please feel free to contact with me
                    <br /><br />
		            I would consider your requests to make this site more great.
                    <br /><br />
                    <span className={styles.confirmStyle}>
                        Confirm your donation of <span className={styles.dollarStyle}>$2 / month</span>
                    </span>
                </p>
            </div>
        )
    }

    paypalBtn = () => {
        var comp = []

        comp.push(<PaySubBtn
            onApprove={this.paypalOnApprove}
            catchError={this.paypalOnError}
            onError={this.paypalOnError}
            onCancel={this.paypalOnError} />)

        return (<div className={styles.paybtnWrapper}>{comp}</div>)
    }

    render() {
        return (
            <div className={styles.container}>
                <div className={styles.wrapper}>
                    {this.donationContent()}
                    {this.wallpaperDespComp()}
                </div>
                {this.paypalBtn()}
            </div>
        )
    }
}
